import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
  padding: "50px 0px 10px 0px",
};

export const content: Record<string, CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    flexShrink: 0,
    paddingTop: 5,
  },
};

export const signupBtn: Record<string, CSSProperties> = {
  base: {
    height: 45,
    lineHeight: `45px`,
    width: "100%",
  },
  label: {
    fontSize: size.md,
    paddingLeft: spacing.std,
    paddingRight: spacing.lg,
    color: greys.white,
    textTransform: "none",
  },
};
